import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './download-button.styl'
import MaterialLoader from '../../../components/loaders/MaterialLoader/MaterialLoader'
import config from '../../../config'
import { connect } from 'react-redux'
import { get } from 'lodash'


@connect(({ auth }) => ({
    authCode: get(auth, 'user.blobAccessAuthorizationCode'),
    token: get(auth, 'user.access_token')
  }))
class DownloadButton extends Component {
  static propTypes = {
    authCode: PropTypes.string,
    download: PropTypes.bool,
    token: PropTypes.string,
    url: PropTypes.string,
    apiParams: PropTypes.bool,
    wrapperClassName: PropTypes.string,
    extraWide: PropTypes.bool,
    fullWidth: PropTypes.bool,
    isLoading: PropTypes.bool,
    secondary: PropTypes.bool,
    uppercase: PropTypes.bool,
    addIcon: PropTypes.bool,
    rounded: PropTypes.bool,
    warning: PropTypes.bool,
    medium: PropTypes.bool,
    padded: PropTypes.bool,
    submit: PropTypes.bool,
    large: PropTypes.bool,
    oval: PropTypes.bool,
    high: PropTypes.bool,
    disabled: PropTypes.bool,
    flat: PropTypes.bool,
    negative: PropTypes.bool,
    inline: PropTypes.bool,
    onClick: PropTypes.func,
    link: PropTypes.bool,
    intlKey: PropTypes.string,
    colorClass: PropTypes.string,
    small: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    download: true,
    component: 'span',
    extraWide: false,
    fullWidth: false,
    isLoading: false,
    uppercase: false,
    addIcon: false,
    warning: false,
    rounded: false,
    medium: false,
    padded: false,
    large: false,
    oval: false,
    high: false,
    submit: false
  }

    state = {
      url: '#',
      isLoading: false
    }

  handleClick = e => {
    e.stopPropagation()

    if (this.isLoading || (this.state.url && this.state.url !== '#')) {
      return
    }

    const { authCode, url, token, apiParams } = this.props

    let fetchUrl = config.apiURL + url

    if (apiParams) {
      const params = 'userType=participant'

      fetchUrl = fetchUrl.includes('?')
        ? fetchUrl + '&' + params
        : fetchUrl + '?' + params
    }

    this.setState({ isLoading: true })

    return fetch(fetchUrl, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => (res.ok ? res.json() : { url: '' }))
      .then(res => {
        this.setState({ isLoading: false })

        const prefix = res.url.includes('?') ? '&' : '?'

        this.setState(
          { url: res.url + `${prefix}authorizationCode=${authCode}` },
          () => this.link.click()
        )
      })
  }

  render() {
    const {
      extraWide,
      fullWidth,
      isLoading,
      uppercase,
      addIcon,
      warning,
      rounded,
      intlKey,
      padded,
      medium,
      large,
      oval,
      high,
      children,
      colorClass,
      disabled,
      flat,
      small,
      negative,
      inline,
      className,
      link,
      secondary,
      download
    } = this.props

    const classNames = [styles.wrap, className]

    const linkClass = [className, styles.unclickable]

    if (!this.isLoading && this.state.url && this.state.url !== '#') {
      linkClass.length = 1
    }

    extraWide && classNames.push(styles.extraWide)
    fullWidth && classNames.push(styles.fullWidth)
    isLoading && classNames.push(styles.isLoading)
    uppercase && classNames.push(styles.uppercase)
    addIcon && classNames.push(styles.addIcon)
    warning && classNames.push(styles.warning)
    small && classNames.push(styles.small)
    rounded && classNames.push(styles.rounded)
    padded && classNames.push(styles.padded)
    medium && classNames.push(styles.medium)
    large && classNames.push(styles.large)
    oval && classNames.push(styles.oval)
    high && classNames.push(styles.high)
    colorClass && classNames.push(styles[colorClass])
    disabled && classNames.push(styles.disabled)
    flat && classNames.push(styles.flat)
    negative && classNames.push(styles.negative)
    inline && classNames.push(styles.inline)
    secondary && classNames.push(styles.secondary)
    link && classNames.push(styles.link)

    return (
        <button
          {...this.props}
          onClick={this.handleClick}
          isLoading={this.state.isLoading}
          className={classNames.join(' ')}
        >
          <a
            className={linkClass.join(' ')}
            ref={c => (this.link = c)}
            href={this.state.url}
            download={download}
            style={{ textDecoration: 'none' }}
          >
          {isLoading &&
          <div className={styles.loader}>
            <MaterialLoader white={!secondary} small />
          </div>}
          {addIcon && <i className={`ico ico--add ${styles.add}`} />}
          {intlKey
            ? <FormattedMessage
              id={intlKey}
              defaultMessage={typeof children === 'string' ? children : ''}
            />
            : children}
          </a>
        </button>
    )
   }
  }

  export default DownloadButton
